import { HandySvg } from "handy-svg";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import iconPointerLeft from "../../assets/icons/svg-sprite/point-arrow-left.svg";
import iconPointerRight from "../../assets/icons/svg-sprite/point-arrow-right.svg";
import { user } from "../../lib/api/api";
import reviewBanner from "../../assets/images/banners/reviewBanner.jpg";
import iconCross from "../../assets/icons/svg-sprite/close-cross--small.svg";
import iconAttention from "../../assets/icons/svg-sprite/attention.svg";
import closeBanner from "../../modules/close-banner";
import fixedMessage from "../../modules/fixed-message";

const ReviewBonus = ({ message, setMessage }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(0);
  const [date, setDate] = useState("");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    closeBanner();
    fixedMessage();
  }, []);

  useEffect(() => {
    const parameters = window.location.search.substr(1);
    if (parameters) {
      const obj = parameters.split("&").reduce((res, a) => {
        var t = a.split("=");
        res[decodeURIComponent(t[0])] =
          t.length == 1 ? null : decodeURIComponent(t[1]);
        return res;
      }, {});
      if (obj.state && obj.state === "0") {
        const banner = document.getElementById("messageBanner");
        banner.style.removeProperty("display");
        setMessage(
          "Привязать аккаунт Яндекс не удалось. Пожалуйста, повторите попытку позже",
        );
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const style = {
    marginLeft: width < 768 && "auto",
    marginRight: width < 768 && "auto",
    marginTop: 50,
    maxWidth: 370,
  };

  useEffect(() => {
    user
      .userInfo()
      .then((res) => {
        setLoading(true);
        setStatus(res.social.status);
        setDate(res.social.date);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function changeOfDate(date) {
    return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
  }

  const handleLinking = (e) => {
    e.preventDefault();
    window.location.replace("https://cabinet.telekarta.tv/api/socials/yandex");
  };

  return (
    <>
      {!loading && <div className="preloader__wrapper" />}
      <div
        className="content__article-wrap"
        style={loading ? {} : { overflow: "hidden", height: "0px", margin: 0 }}
      >
        <article className="step-process-article">
          <div className="step-process-article__inner content-columns page-container">
            <div className="step-process-article__main content-columns__main js-section">
              <div className="cart__header">
                <div className="cart__header-inner">
                  <Link className="cart__return" to="/">
                    <HandySvg
                      className="svg-icon cart__return-icon"
                      src={iconPointerLeft}
                      width="18"
                      height="10"
                    />
                    <span className="cart__return-text">
                      Вернуться на главную
                    </span>
                  </Link>
                  <h1 className="cart__title title title--h2">
                    Бонус за отзыв
                  </h1>
                </div>
              </div>
              <div className="wysiwyg">
                <p>
                  <strong>30 дней премиум-каналов</strong>
                </p>
                <p style={{ marginBottom: 30 }}>
                  Хотите смотреть лучшие фильмы и передачи без доплат? Оставьте
                  честный отзыв о Телекарте на Яндексе — и мы подарим вам месяц
                  подписки на самые рейтинговые телеканалы! Это просто и займет
                  всего пару минут.
                </p>
              </div>
              <form className="step-process" onSubmit={handleLinking}>
                <ol className="step-process__list">
                  <li className="step-process__item">
                    <div className="step-process__number" />
                    {status === 0 ? (
                      <div className="step-process__order">
                        <div className="step-process__title">
                          Привяжите аккаунт (Яндекс ID)
                        </div>
                        <div className="step-process__description">
                          Для привязки Яндекс ID перейдите ссылке
                        </div>
                        <button
                          className="ghost-btn ghost-btn--blue bttn"
                          type="submit"
                          style={{ marginTop: 5 }}
                        >
                          Привязать Яндекс ID
                        </button>
                      </div>
                    ) : (
                      <div className="step-process__order">
                        <div className="step-process__title">
                          Аккаунт привязан
                        </div>
                        <div className="step-process__description">
                          Ваш Яндекс ID успешно подключен. Отлично, двигаемся
                          дальше!
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="step-process__item">
                    <div
                      className={
                        (status === 0 ? "inactive " : "") +
                        "step-process__number"
                      }
                    />
                    <div className="step-process__order">
                      <div className="step-process__title">
                        Напишите отзыв на Яндекс Картах
                      </div>
                      <div className="step-process__description">
                        Перейдите по ссылке, чтобы оставить отзыв о Телекарте.
                        Нам важно ваше мнение!
                      </div>
                      <Link
                        className="ghost-btn ghost-btn--blue bttn"
                        target="_blank"
                        to="https://yandex.ru/maps/-/CPbPVZLA"
                        style={{ marginTop: 5 }}
                      >
                        Оставить отзыв
                      </Link>
                    </div>
                  </li>
                  {status === 2 ? (
                    <li className="step-process__item">
                      <div className="step-process__number" />
                      <div className="step-process__order">
                        <div className="step-process__title">
                          Подарок активирован!
                        </div>
                        <div className="step-process__description">
                          Ура, спасибо за отзыв! Ваш персональный доступ к
                          рейтинговым телеканалам подключен
                          {date.trim() !== "" && ` ${changeOfDate(date)}`}.
                          Приятного просмотра!
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li className="step-process__item">
                      <div className="step-process__number inactive" />
                      <div className="step-process__order">
                        <div className="step-process__title">
                          Ожидание проверки
                        </div>
                        <div className="step-process__description">
                          Как только наш робот найдет ваш новый отзыв (обычно
                          это происходит в течение двух дней), мы сразу
                          активируем вам подарок. Никаких лишних действий!
                        </div>
                      </div>
                    </li>
                  )}
                </ol>
              </form>
              <div
                id="messageBanner"
                className="info-cards__message-container js-closing-banner js-fixed-message"
                style={{ display: "none" }}
              >
                <div className="info-cards__message">
                  <div className="info-cards__message-content">
                    <HandySvg
                      className="svg-icon"
                      src={iconAttention}
                      width="36"
                      height="36"
                    />
                    <div className="info-cards__message-text">{message}</div>
                  </div>
                  <button
                    className="js-close-btn info-cards__message-btn"
                    type="button"
                  >
                    <HandySvg
                      className="svg-icon"
                      src={iconCross}
                      width="13"
                      height="12"
                    />
                  </button>
                </div>
              </div>
            </div>
            <aside
              className="common-article__aside content-columns__aside"
              style={style}
            >
              <div className="content-columns__aside-cell">
                <div className="content-aside-widget page__area">
                  <div className="content-aside-widget__header">
                    <span className="content-aside-widget__label">
                      Подробнее об акции
                    </span>
                  </div>
                  <div className="content-aside-widget__body">
                    <div className="content-aside-widget__img">
                      <img
                        src={reviewBanner}
                        width="310"
                        height="175"
                        alt="Месяц любимых каналов в подарок"
                      />
                    </div>
                    <h4 className="content-aside-widget__title">
                      Месяц любимых каналов в подарок
                    </h4>
                    <div className="content-aside-widget__description">
                      <p>
                        Оставьте отзыв о Телекарте на Яндекс Картах и получите
                        доступ к коллекции самых рейтинговых телеканалов на 30
                        дней. Кино, спорт, развлечения — все самое интересное
                        будет ждать вас!
                      </p>
                    </div>
                  </div>
                  <div className="content-aside-widget__footer">
                    <Link
                      className="content-aside-widget__btn solid-btn solid-btn--pink solid-btn--md bttn"
                      target="_blank"
                      to="https://www.telekarta.tv/actions/2291/"
                    >
                      Подробнее
                      <HandySvg
                        className="svg-icon solid-btn__arrow-right"
                        src={iconPointerRight}
                        width="19"
                        height="10"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </article>
      </div>
    </>
  );
};

export default ReviewBonus;
